import CustomTableRow from 'ui/table/CustomTableRow'
import { TABLE_HEAD } from './constants'

export const TableHeader = () => {
	return (
		<CustomTableRow
			rowKey={TABLE_HEAD.rowKey}
			cellItems={TABLE_HEAD.cellItems}
			rowBorderBottom={TABLE_HEAD.rowBorderBottom}
			rowHeight={TABLE_HEAD.rowHeight}
		/>
	)
}
